import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ObjectFieldEntity } from './object-field.entity';

@Index(
	'_object_field_validator__fk__object_field__id_foreign',
	['fkObjectFieldId'],
	{},
)
@Entity('_object_field_validator')
export class ObjectFieldValidatorEntity extends BaseEntity {
	@Column('int', {
		name: '_fk__object_field__id',
		nullable: true,
		unsigned: true,
	})
	public fkObjectFieldId!: number | null;

	@Column('varchar', { name: 'type', nullable: true, length: 20 })
	public type!: string | null;

	@Column('varchar', { name: 'value', nullable: true, length: 255 })
	public value!: string | null;

	@ManyToOne(
		() => ObjectFieldEntity,
		(objectField) => objectField.objectFieldValidators,
		{ onDelete: 'CASCADE', onUpdate: 'RESTRICT' },
	)
	@JoinColumn([{ name: '_fk__object_field__id', referencedColumnName: 'id' }])
	public fkObjectField!: ObjectFieldEntity;
}
